/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import { Barcode, Camera, File } from 'assets/images'
import { Container } from '@mui/material'
import Button from 'components/Button/Index'
import Header from 'components/Header/Index'
import { Scanner } from '@yudiel/react-qr-scanner'

function Home() {
  const [showScanner, setShowScanner] = useState(false)

  const handleScanQRCode = () => {
    setShowScanner(true)
  }

  const handleScanResult = (detectedCodes: any[]) => {
    if (detectedCodes && detectedCodes.length > 0) {
      const result = detectedCodes[0].rawValue
      try {
        // If it's a valid URL, redirect to it
        window.location.href = result
      } catch (error) {
        // If not a valid URL, just show the result
        alert(`QR Code detected: ${result}`)
      }
      setShowScanner(false)
    }
  }

  const handleScanError = (error: unknown) => {
    console.error('QR Scanner Error:', error)
    alert('Error accessing camera. Please check camera permissions.')
    setShowScanner(false)
  }

  const handleCloseScan = () => {
    setShowScanner(false)
  }

  useEffect(() => {
    document.title = 'Home | FasTab'
  }, [])

  return (
    <>
      {/* header component */}
      <>
        <Header />
      </>
      {/* header component end */}
      {/* wrapper start */}
      <section className="wrapper home">
        <Container maxWidth="md">
          <h1>Quickly Pay Your Tab</h1>
          <span>View, split and pay your tab with your phone</span>
          <ul>
            <li>
              <p className="scan-text">1.</p>
              <p className="scan-text">
                Click &apos;Scan QR Code&apos; below to open the scanner
              </p>
              <img src={Camera} alt="Camera" />
            </li>
            <li>
              <p className="scan-text">2.</p>
              <p className="scan-text">
                Point your camera at the QR code on your table
              </p>
              <img src={Barcode} alt="Barcode" />
            </li>
            <li>
              <p className="scan-text">3.</p>
              <p className="scan-text">
                The QR code will be detected automatically and open your tab!
              </p>
              <img src={File} alt="File" />
            </li>
          </ul>
          <h1>Quickly Pay Your Tab</h1>
          <p className="styled-text">It&apos;s Fast &amp; Easy</p>

          {showScanner ? (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'black',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  zIndex: 10000,
                }}
              >
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={handleCloseScan}
                  title="Close Scanner"
                  size="small"
                >
                  ✕ Close
                </Button>
              </div>
              <Scanner onScan={handleScanResult} onError={handleScanError} />
            </div>
          ) : (
            <>
              <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleScanQRCode}
                  title="Scan QR Code"
                  size="large"
                  className="scan-qr-btn"
                >
                  <span>Scan QR Code</span>
                </Button>
              </div>

              <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                <p style={{ color: '#666', fontSize: '14px' }}>
                  This will open a QR code scanner using your camera
                </p>
              </div>
            </>
          )}
        </Container>
      </section>
      {/* wrapper end */}
    </>
  )
}

export default Home
